import React, { memo, useEffect } from 'react';
import { getAdvData, initAdv } from '@sky-uk/sky-adv';

interface AdvProps {
  $advDataNode?: Element | null;
}

const Adv: React.FC<AdvProps> = ({ $advDataNode }) => {
  const { reviveId, zoneId } = getAdvData($advDataNode as HTMLElement);

  useEffect(() => {
    if ($advDataNode) {
      initAdv($advDataNode as HTMLElement);
    }
  }, [$advDataNode]);

  return <ins data-revive-zoneid={zoneId} data-revive-id={reviveId} />;
};

export default memo(Adv);
